import { createSvg } from '../createSvg';

const Bag = ({ strokeWidth = 1.5 }): JSX.Element => {
    return <g id={'contour'}>
        <path
            d='M8.80994 2L5.18994 5.63'
            strokeWidth={strokeWidth}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M15.1899 2L18.8099 5.63'
            strokeWidth={strokeWidth}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M2 7.8501C2 6.0001 2.99 5.8501 4.22 5.8501H19.78C21.01 5.8501 22 6.0001 22 7.8501C22 10.0001 21.01 9.8501 19.78 9.8501H4.22C2.99 9.8501 2 10.0001 2 7.8501Z'
            strokeWidth={strokeWidth}
        />
        <path
            d='M9.76001 14V17.55'
            strokeWidth={strokeWidth}
            strokeLinecap='round'
        />
        <path
            d='M14.3601 14V17.55'
            strokeWidth={strokeWidth}
            strokeLinecap='round'
        />
        <path
            d='M3.5 10L4.91 18.64C5.23 20.58 6 22 8.86 22H14.89C18 22 18.46 20.64 18.82 18.76L20.5 10'
            strokeWidth={strokeWidth}
            strokeLinecap='round'
        />
    </g>;
};

export default createSvg(
    Bag,
    'bag',
);
